module.exports = __webpack_public_path__ + "static/media/rodent.0cc8be21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/rodent.svg
// module id = 480
// module chunks = 0